/* import __COLOCATED_TEMPLATE__ from './error.hbs'; */
import Component from '@glimmer/component';
import { addChartFn, getVoltRefErrors, addDetailsForErrorCategory } from '../../utils/error-utils';
import { service } from '@ember/service';
import { action } from '@ember/object';
import Constants from '../../utils/constants';

const TOPOLOGY_INPUTS = Constants.TOPOLOGY_INPUTS;

export default class CurrentSourceSinkError extends Component {
  @service intl;

  @action getErrorData() {
    const findInTopologies = (id) => this.args.model.topologyInputHandler.current.find((t) => t.config.id === id), // switch to ID in future
      dacSelected = this.args.model.signalChainHandler.dac.selected,
      currentSignalChain = this.args.model.signalChainHandler.currentItems,
      outType = findInTopologies(TOPOLOGY_INPUTS.IOUT_OR_VOUT),
      voltRef = currentSignalChain.find((item) => item.isVoltageReference),
      voltRefErrors = getVoltRefErrors(voltRef.selected, dacSelected, this.args.model);

    // DAC
    let dacErrors = []; // calculated differently than most DACs
    const addDacDetails = addDetailsForErrorCategory(dacErrors, this.args.model);
    // TUE Iout Error
    if (outType.selectedOption.id == Constants.TOPOLOGY_OPTIONS.IOUT) {
      const tueIout = this.args.model.signalChainHandler.data.outputRange.tueIoutMax;

      addDacDetails(
        'tue_iout',
        [tueIout],
        tueIout * 10000,
        this.intl.t('messages.error_params_not_available', { errorParams: this.intl.t('labels.errors.tue_iout') }),
        true, // show help topic
      );
    }

    let chartInfo = { charts: [] }; // Array of all charts
    const addChart = addChartFn(chartInfo.charts);
    addChart(this.intl.t('labels.parts.voltage_reference'), Constants.SVG_PARTS.voltage_reference, voltRefErrors);
    addChart(
      this.intl.t('labels.parts.current_source_sink_dac'),
      Constants.SVG_PARTS.current_source_sink_dac,
      dacErrors,
    );
    chartInfo.hasCurrentError = true;
    return chartInfo;
  }
}
